import { AdminGridTable } from "../../../components/admin-console/admin-grid-table";
import { MOCK_SERVICE_PROCESS_VERSIONS, VERSION_TABLE_COLUMNS } from "../service-detail-page.lib";
import { ServiceVersionDetailPanel } from "./version-detail-panel";

/**
 * Блок «Версии процесса»: таблица версий с раскрытием строки (master/detail AG Grid).
 * При раскрытии строки появляется кастомная панель — стадии процесса и применяемые дороги (таблица).
 */
export const VersionsTabContent = () => (
  <AdminGridTable
    tableId="admin-service-versions-table"
    columns={VERSION_TABLE_COLUMNS}
    rows={MOCK_SERVICE_PROCESS_VERSIONS}
    masterDetail
    detailRowAutoHeight
    detailCellRenderer={ServiceVersionDetailPanel}
    className="h-[24rem] min-h-0"
  />
);
